// import 'isomorphic-fetch';
import { authUtilityLoader } from '@consumer/auth-utility-loader';
export const rejectNonOkResponses = response => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
};
const getJsonBody = response => response.json();
const rejectWithError = reason => {
  if (!(reason instanceof Error)) {
    throw Error(reason);
  }
  return reason;
};
const getIdToken = async function (isHeaderAuthorization) {
  if (isHeaderAuthorization === void 0) {
    isHeaderAuthorization = false;
  }
  const {
    getCognitoIdToken
  } = await authUtilityLoader();
  const idtoken = await getCognitoIdToken().catch(() => undefined);
  if (isHeaderAuthorization) {
    return idtoken;
  }
  if (idtoken) {
    return {
      idtoken
    };
  }
  return {};
};
const fetchWithHandlers = function () {
  return fetch(...arguments).then(rejectNonOkResponses).then(getJsonBody).catch(rejectWithError);
};

/*
 *   Handle DELETE Requests to API
 */
export const del = function (url, data, options) {
  if (options === void 0) {
    options = {};
  }
  return fetchWithHandlers(url + (data ? `?${new URLSearchParams(data)}` : ''), {
    method: 'DELETE',
    credentials: 'include',
    ...options
  });
};

/*
 *   Handle GET Requests to API
 */
export const get = function (url, data, options) {
  if (options === void 0) {
    options = {};
  }
  return fetchWithHandlers(url + (data ? `?${new URLSearchParams(data)}` : ''), {
    method: 'GET',
    credentials: 'include',
    ...options
  });
};

/*
 *   Handle POST Requests to API
 */
export const post = function (url, data, _temp) {
  let {
    headers = {},
    ...remainingOptions
  } = _temp === void 0 ? {} : _temp;
  return fetchWithHandlers(url, {
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      ...headers
    },
    ...remainingOptions
  });
};

/*
 *   Handle PUT Requests to API
 */
export const put = function (url, data, _temp2) {
  let {
    headers = {},
    ...remainingOptions
  } = _temp2 === void 0 ? {} : _temp2;
  return fetchWithHandlers(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      ...headers
    },
    ...remainingOptions
  });
};
const accountApiWrapper = wrappedMethod => async function (url, data, options) {
  if (options === void 0) {
    options = {};
  }
  return wrappedMethod(url, {
    ...data
  }, {
    credentials: 'omit',
    ...options,
    headers: {
      ...options.headers
    }
  });
};
const userAccountApiWrapper = wrappedMethod => async function (url, data, options) {
  if (options === void 0) {
    options = {};
  }
  return wrappedMethod(url, {
    ...data
  }, {
    credentials: 'omit',
    ...options,
    headers: {
      ...options.headers
    }
  });
};
export const accountApiGet = accountApiWrapper(get);
export const accountApiPost = accountApiWrapper(post);
const cognitoAuthWrapper = function (wrappedMethod, userApi) {
  if (userApi === void 0) {
    userApi = false;
  }
  const apiWrappedMethod = userApi ? userAccountApiWrapper(wrappedMethod) : accountApiWrapper(wrappedMethod);
  return async function (url, data, options) {
    if (options === void 0) {
      options = {};
    }
    return apiWrappedMethod(url, data, {
      ...options,
      headers: {
        ...(await getIdToken()),
        ...options.headers
      }
    });
  };
};
const psxNotificationsApiWrapper = wrappedMethod => async function (url, data, options) {
  if (options === void 0) {
    options = {};
  }
  return wrappedMethod('/psx-notifications', {
    ...data
  }, {
    ...options,
    headers: {
      Authorization: `Bearer ${await getIdToken(true)}`,
      ...options.headers
    }
  });
};
export const cognitoAuthenticatedGet = cognitoAuthWrapper(get);
export const cognitoAuthenticatedPost = cognitoAuthWrapper(post);
export const cognitoAuthenticatedDelete = cognitoAuthWrapper(del);
export const userApiCognitoAuthenticatedGet = cognitoAuthWrapper(get, true);
export const userApiCognitoAuthenticatedPost = cognitoAuthWrapper(post, true);
export const userApiCognitoAuthenticatedDelete = cognitoAuthWrapper(del, true);
export const userApiCognitoAuthenticatedPut = cognitoAuthWrapper(put, true);
export const psxNotificationsCognitoAuthenticatedPost = psxNotificationsApiWrapper(post);